import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import EventRepeatOutlinedIcon from "@mui/icons-material/EventRepeatOutlined";
import FlightTakeoffOutlinedIcon from "@mui/icons-material/FlightTakeoffOutlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";

export const CATEGORY_LABELS = {
  assessment: "Assessment",
  counselling: "Counselling",
  admissions: "College Admissions",
};

export const PRICE_TYPE_LABELS = {
  free: "Free",
  fixed: "Fixed price",
  custom: "Customized",
};

// One accent per card position, so every card gets its own colour.
const ACCENTS = [
  { main: "#059669", soft: "#ECFDF5", gradient: "linear-gradient(135deg, #34D399 0%, #059669 100%)" },
  { main: "#2563EB", soft: "#EFF6FF", gradient: "linear-gradient(135deg, #60A5FA 0%, #2563EB 100%)" },
  { main: "#7C3AED", soft: "#F5F3FF", gradient: "linear-gradient(135deg, #A78BFA 0%, #7C3AED 100%)" },
  { main: "#EA580C", soft: "#FFF7ED", gradient: "linear-gradient(135deg, #FBBF24 0%, #F6AA48 45%, #EA580C 100%)" },
  { main: "#DB2777", soft: "#FDF2F8", gradient: "linear-gradient(135deg, #F472B6 0%, #DB2777 100%)" },
  { main: "#0284C7", soft: "#F0F9FF", gradient: "linear-gradient(135deg, #38BDF8 0%, #4F46E5 100%)" },
];

export const getPlanAccent = (index) => ACCENTS[index % ACCENTS.length];

export const getPlanIcon = (plan) => {
  const title = (plan.title || "").toLowerCase();

  if (plan.category === "assessment") return PsychologyOutlinedIcon;
  if (plan.category === "admissions") {
    return /foreign|abroad|international/.test(title)
      ? FlightTakeoffOutlinedIcon
      : AccountBalanceOutlinedIcon;
  }
  if (title.includes("year")) return EventRepeatOutlinedIcon;
  if (title.includes("general")) return ForumOutlinedIcon;
  return RouteOutlinedIcon;
};

export const formatRupees = (value) =>
  `₹${Math.round(Number(value) || 0).toLocaleString("en-IN")}`;
